import {
	Outlet,
	RouteObject
} from "react-router";
import { EmbedAppPageForRouter, embedAppRouting } from "../Embed/EmbedAppPage";
import { EmailForRouter, emailRouting } from "../Email/Email";
import { ErrorPage } from "../ErrorPage/ErrorPage";
import { ErrorPageContainer } from "../ErrorPage/ErrorPageContainer";
import { OverviewPageForRouter as AddressBookOverviewPage } from "../AddressBook/OverviewPage";
import { hubRouting } from "../Hub/routing";
import { SettingsLayout } from "../Settings/SettingsLayout";
import { CalendarPageForRouter, calendarRouting } from "../Calendar/CalendarPage";
import { billingRouting, BillingPage } from "../Settings/Licensing/Billing/Page";
import {
	Page as AuditLogsPage,
	auditLogsRouting
} from "../Settings/AuditLogging/Page";
import { ManageUserRequestsPage, manageUserRequestsRouting } from "../Settings/UserRequests/ManageUserRequestsPage";
import { ApiKeysOverview, apiKeysRouting } from "../Settings/ApiKeys/Overview";
import { AfasConnectionPage, afasConfigurationRouting } from "../Settings/Connections/Afas/Page";
import { AutotaskConnectionPage, autotaskConfigurationRouting } from "../Settings/Connections/Autotask/Page";
import { EgnyteConnectionPage, egnyteConfigurationRouting } from "../Settings/Connections/Egnyte/Page";
import { WebDavSettings, webDavSettingsRouting } from "../Settings/WebDavSettings/WebDavSettings";
import { LiquitConnectionPage, liquitConfigurationRouting } from "../Settings/Connections/Liquit/Page";
import { MagisterConnectionPage, magisterConfigurationRouting } from "../Settings/Connections/Magister/Page";
import { NedapOnsConnectionPage, nedapOnsConfigurationRouting } from "../Settings/Connections/NedapOns/Page";
import { SharePointSettingsPage, sharePointSettingsRouting } from "../Settings/SharePoint/SharePointSettingsPage";
import { TopDeskConnectionPage, topDeskConfigurationRouting } from "../Settings/Connections/TopDesk/Page";
import { VilansKickConnectionPage, vilansKickConfigurationRouting } from "../Settings/Connections/VilansKick/Page";
import { ZaaksysteemConnectionPage, zaaksysteemConfigurationRouting } from "../Settings/Connections/Zaaksysteem/Page";
import { ZenyaConnectionPage, zenyaConfigurationRouting } from "../Settings/Connections/Zenya/Page";
import { ZermeloConnectionPage, zermeloConfigurationRouting } from "../Settings/Connections/Zermelo/Page";
import { UserProvisioningPage, userProvisioningRouting } from "../Settings/UserProvisioning/UserProvisioningPage";
import { UserManagementPageForRouter, userManagementRouting } from "../Settings/UserManagement/UserManagementPage";
import { EditUserPageForRouter } from "../Settings/UserManagement/EditUserPage";
import { ImportUserPageForRouter, importUsersRouting } from "../Settings/UserManagement/ImportUserPage";
import { ImportUserGroupPageForRouter } from "../Settings/UserManagement/ImportUserGroupPage";
import {
	OverviewPageForRouter as IntegrationCredentialsOverview,
	integrationCredentialsRouting
} from "../Settings/IntegrationCredentials/OverviewPage";
import { environmentEmailSettingsRouting, EnvironmentEmailPage } from "../Settings/Email/EnvironmentSettings/EnvironmentEmailPage";
import { EditIntegrationCredentialsPageForRouter } from "../Settings/IntegrationCredentials/EditIntegrationCredentialsPage";
import { GatewayOverviewForRouter, clientlessRdpRouting } from "../Settings/ClientlessRdp/GatewayOverview";
import { GatewayConfigurationForRouter } from "../Settings/ClientlessRdp/GatewayConfiguration";
import { ConnectionConfigurationForRouter } from "../Settings/ClientlessRdp/ConnectionConfiguration";
import {
	ApplyPassword as ApplyPasswordPage,
	applyPasswordPageRouting
} from "../Settings/UserProfile/ApplyPassword";
import { SingleSignOnSettingsPage, singleSignOnSettingsRouting } from "../Settings/SsoSettings/Page";
import { UserGroupManagementPageForRouter, userGroupManagementRouting } from "../Settings/UserGroupManagement/UserGroupManagementPage";
import { EditUserGroupPageForRouter } from "../Settings/UserGroupManagement/EditUserGroupPage";
import { workspaceManagementRouting, WorkspaceManagement } from "../Settings/WorkspaceManagement/WorkspaceManagement";
import { UserProfilePageForRouter, userProfileRouting } from "../Settings/UserProfile/UserProfilePage";
import { UserProfileEditForRouter } from "../Settings/UserProfile/UserProfileEdit";
import { BrandingOverviewForRouter, brandingRouting } from "../Settings/Branding/Overview/BrandingOverview";
import { BrandingSettingFormForRouter } from "../Settings/Branding/EditBranding/BrandingSettingForm";
import { SecurityConfigurationPage, securityConfigurationRouting } from "../Settings/SecurityConfiguration/SecurityConfigurationPage";
import { TermsPage, termsRouting } from "../Settings/Terms/TermsPage";
import { userLicensingManagementRouting, Page as UserLicensingManagementPage } from "../Settings/Licensing/Licensing/Page";
import { environmentExchangeSettingsRouting, ExchangeSettings as EnvironmentExchangeSettingsPage } from "../Settings/ExchangeSettings/ExchangeSettings";
import {
	PermissionManagementPage as UserGroupPermissionOverview,
	userGroupPermissionRouting
} from "../Settings/UserGroupPermissions/PermissionManagementPage";
import { searchRouting } from "../Search/routing";
import { SearchPageForRouter } from "../Search/SearchPage";
import { AddressBookLayoutForRouter } from "../AddressBook/AddressBookLayout";
import { AddressBookSelectSourceForRouter } from "../AddressBook/AddressBookSelectSource";
import { DetailsPageForRouter as AddressBookDetailsPage } from "../AddressBook/DetailsPage";
import { addressBookRouting } from "../AddressBook/routing";
import { UserLicenseManagementPageForRouter, userLicenseManagementRouting } from "../Settings/Licensing/UserLicenseManagement/UserLicenseManagementPage";
import { EditUserLicensePageForRouter } from "../Settings/Licensing/UserLicenseManagement/EditUserLicensePage";
import { AnalyticsPage, AnalyticsRouting } from "../Settings/Analytics/Page";
import { SibiConnectionPage, sibiConfigurationRouting } from "../Settings/Connections/Sibi/Page";
import { IntercomConnectionPage, intercomConfigurationRouting } from "../Settings/Connections/Intercom/Page";
import {
	IntegrationBuilderOverViewForRouter as IntegrationBuilderOverViewPage,
	integrationBuilderRouting,
} from "../Settings/IntegrationBuilder/OverViewPage";
import { EditIntegrationAppPageForRouter } from "../Settings/IntegrationBuilder/EditIntegrationAppPage";
import { EditIntegrationFlowPageForRouter } from "../Settings/IntegrationBuilder/EditIntegrationFlowPage";
import { HubLayoutForRouter } from "../Hub/HubLayout";
import { AnnouncementsPageForRouter } from "../Hub/Announcements/AnnouncementsPage";
import { KnowledgeItemsPageForRouter } from "../Hub/KnowledgeItems/KnowledgeItemsPage";
import { EventsPageForRouter } from "../Hub/Events/EventsPage";
import { HubOverviewPageForRouter } from "../Hub/HubOverviewPage";
import { SearchSettingsPage, SearchSettingsRouting } from "../Settings/Search/SearchSettingsPage";
import { CommunitiesPageForRouter } from "../Hub/Communities/CommunitiesPage";
import { CommunityPostPageForRouter } from "../Hub/Communities/CommunityPostPage";
import { AiAssistantSettingsPage, AiAssistantSettingsRouting } from "../Settings/AiAssistant/Page";
import { RoadmapPage, roadmapRouting } from "../Roadmap/RoadmapPage";
import { WorkspaceForRouter } from "../Workspace/Workspace";
import { workspaceRouting } from "../Workspace/routing";

export const appRoutes: RouteObject[] = [
	{
		element: <AddressBookLayoutForRouter><Outlet /></AddressBookLayoutForRouter>,
		children: [
			{
				path: addressBookRouting.autoSelectSource,
				element: <AddressBookSelectSourceForRouter />
			},
			{
				path: addressBookRouting.overview.definition,
				element: <AddressBookOverviewPage />
			},
			{
				path: addressBookRouting.details.definition,
				element: <AddressBookDetailsPage />
			}
		]
	},
	{
		path: embedAppRouting.page.definition,
		element: <EmbedAppPageForRouter />
	},
	{
		path: emailRouting.page.definition,
		element: <EmailForRouter />
	},
	{
		element: <HubLayoutForRouter><Outlet /></HubLayoutForRouter>,
		children: [
			{
				path: hubRouting.page.definition,
				element: <HubOverviewPageForRouter />
			},
			{
				path: hubRouting.announcements.definition,
				element: <AnnouncementsPageForRouter />
			},
			{
				path: hubRouting.knowledgeItems.definition,
				element: <KnowledgeItemsPageForRouter />
			},
			{
				path: hubRouting.events.definition,
				element: <EventsPageForRouter />
			},
			{
				path: hubRouting.communities.overviews.definition,
				element: <CommunitiesPageForRouter />
			},
			{
				path: hubRouting.communities.post.definition,
				element: <CommunityPostPageForRouter />
			},
		]
	},
	{
		path: calendarRouting.page.definition,
		element: <CalendarPageForRouter />
	},
	{
		path: searchRouting.page.definition,
		element: <SearchPageForRouter />
	},
	{
		path: roadmapRouting.page,
		element: <RoadmapPage />
	},
	{
		path: workspaceRouting.page.definition,
		element: <WorkspaceForRouter />
	},
	{
		path: workspaceRouting.pageWithSpace.definition,
		element: <WorkspaceForRouter />
	},
	{
		element: <SettingsLayout><Outlet /></SettingsLayout>,
		children: [
			{
				path: userProfileRouting.page,
				element: <UserProfilePageForRouter />
			},
			{
				path: userProfileRouting.edit,
				element: <UserProfileEditForRouter />
			},
			{
				path: billingRouting.page,
				element: <BillingPage />
			},
			{
				path: AnalyticsRouting.page,
				element: <AnalyticsPage />
			},
			{
				path: auditLogsRouting.page,
				element: <AuditLogsPage />
			},
			{
				path: manageUserRequestsRouting.page,
				element: <ManageUserRequestsPage />
			},
			{
				path: apiKeysRouting.overview,
				element: <ApiKeysOverview />
			},
			{
				path: afasConfigurationRouting.page,
				element: <AfasConnectionPage />
			},
			{
				path: autotaskConfigurationRouting.page,
				element: <AutotaskConnectionPage />
			},
			{
				path: egnyteConfigurationRouting.page,
				element: <EgnyteConnectionPage />
			},
			{
				path: webDavSettingsRouting.page,
				element: <WebDavSettings />
			},
			{
				path: liquitConfigurationRouting.page,
				element: <LiquitConnectionPage />
			},
			{
				path: magisterConfigurationRouting.page,
				element: <MagisterConnectionPage />
			},
			{
				path: nedapOnsConfigurationRouting.page,
				element: <NedapOnsConnectionPage />
			},
			{
				path: sharePointSettingsRouting.page,
				element: <SharePointSettingsPage />
			},
			{
				path: topDeskConfigurationRouting.page,
				element: <TopDeskConnectionPage />
			},
			{
				path: vilansKickConfigurationRouting.page,
				element: <VilansKickConnectionPage />
			},
			{
				path: zaaksysteemConfigurationRouting.page,
				element: <ZaaksysteemConnectionPage />
			},
			{
				path: zenyaConfigurationRouting.page,
				element: <ZenyaConnectionPage />
			},
			{
				path: zermeloConfigurationRouting.page,
				element: <ZermeloConnectionPage />
			},
			{
				path: userProvisioningRouting.page,
				element: <UserProvisioningPage />
			},
			{
				path: userManagementRouting.overview,
				element: <UserManagementPageForRouter />
			},
			{
				path: userManagementRouting.create,
				element: <EditUserPageForRouter />
			},
			{
				path: userManagementRouting.edit.definition,
				element: <EditUserPageForRouter />
			},
			{
				path: importUsersRouting.page,
				element: <ImportUserPageForRouter />
			},
			{
				path: importUsersRouting.fromOffice365GroupsPage,
				element: <ImportUserGroupPageForRouter />
			},
			{
				path: integrationCredentialsRouting.overview,
				element: <IntegrationCredentialsOverview />
			},
			{
				path: integrationCredentialsRouting.create,
				element: <EditIntegrationCredentialsPageForRouter />
			},
			{
				path: integrationCredentialsRouting.edit.definition,
				element: <EditIntegrationCredentialsPageForRouter />
			},
			{
				path: environmentEmailSettingsRouting.page,
				element: <EnvironmentEmailPage />
			},
			{
				path: clientlessRdpRouting.gatewayOverview,
				element: <GatewayOverviewForRouter />
			},
			{
				path: clientlessRdpRouting.createGateway,
				element: <GatewayConfigurationForRouter isReadOnly={false} />
			},
			{
				path: clientlessRdpRouting.gatewayDetails.definition,
				element: <GatewayConfigurationForRouter isReadOnly />
			},
			{
				path: clientlessRdpRouting.editGateway.definition,
				element: <GatewayConfigurationForRouter isReadOnly={false} />
			},
			{
				path: clientlessRdpRouting.createConnection.definition,
				element: <ConnectionConfigurationForRouter isReadOnly={false} />
			},
			{
				path: clientlessRdpRouting.connectionDetails.definition,
				element: <ConnectionConfigurationForRouter isReadOnly />
			},
			{
				path: clientlessRdpRouting.editConnection.definition,
				element: <ConnectionConfigurationForRouter isReadOnly={false} />
			},
			{
				path: applyPasswordPageRouting.page,
				element: <ApplyPasswordPage />
			},
			{
				path: singleSignOnSettingsRouting.page,
				element: <SingleSignOnSettingsPage />
			},
			{
				path: userGroupManagementRouting.overview,
				element: <UserGroupManagementPageForRouter />
			},
			{
				path: userGroupManagementRouting.create,
				element: <EditUserGroupPageForRouter />
			},
			{
				path: userGroupManagementRouting.edit.definition,
				element: <EditUserGroupPageForRouter />
			},
			{
				path: workspaceManagementRouting.page,
				element: <WorkspaceManagement />
			},
			{
				path: brandingRouting.overview,
				element: <BrandingOverviewForRouter />
			},
			{
				path: brandingRouting.new,
				element: <BrandingSettingFormForRouter />
			},
			{
				path: brandingRouting.edit.definition,
				element: <BrandingSettingFormForRouter />
			},
			{
				path: securityConfigurationRouting.path,
				element: <SecurityConfigurationPage />
			},
			{
				path: termsRouting.page,
				element: <TermsPage />
			},
			{
				path: userLicensingManagementRouting.page,
				element: <UserLicensingManagementPage />
			},
			{
				path: environmentExchangeSettingsRouting.page,
				element: <EnvironmentExchangeSettingsPage />
			},
			{
				path: userGroupPermissionRouting.overview,
				element: <UserGroupPermissionOverview />
			},
			{
				path: userLicenseManagementRouting.overview,
				element: <UserLicenseManagementPageForRouter />
			},
			{
				path: userLicenseManagementRouting.edit.definition,
				element: <EditUserLicensePageForRouter />
			},
			{
				path: sibiConfigurationRouting.page,
				element: <SibiConnectionPage />
			},
			{
				path: intercomConfigurationRouting.page,
				element: <IntercomConnectionPage />
			},
			{
				path: integrationBuilderRouting.overview,
				element: <IntegrationBuilderOverViewPage />
			},
			{
				path: integrationBuilderRouting.editApp.definition,
				element: <EditIntegrationAppPageForRouter />
			},
			{
				path: integrationBuilderRouting.newFlow.definition,
				element: <EditIntegrationFlowPageForRouter />
			},
			{
				path: integrationBuilderRouting.editFlow.definition,
				element: <EditIntegrationFlowPageForRouter />
			},
			{
				path: SearchSettingsRouting.page,
				element: <SearchSettingsPage />
			},
			{
				path: AiAssistantSettingsRouting.page,
				element: <AiAssistantSettingsPage />
			},
		]
	},
	{
		path: "*",
		element: (
			<ErrorPageContainer>
				<ErrorPage httpCode={404} />
			</ErrorPageContainer>
		)
	}
];